import React from 'react'

import { Box, Text } from 'grommet'
import { useNavigate } from 'react-router-dom'



import FontAwesome from '../../../components/compound/fontAwesome/FontAwesome'

import LocalStorageService from '../../../services/LocalStorageService'
import { useEffect, useState } from 'react'
import ActionButton from '../../../components/compound/actionButton/ActionButton'

const AILinkBar = (props) => {
  // replace the name of the service user with the stored term
  const terms = LocalStorageService.get('terms')
  const activeOrg = LocalStorageService.get('activeOrg') 
  const user = LocalStorageService.get('userDetails')

  const navigate = useNavigate()

  const [links, setLinks] = useState([])

  useEffect(() => {
    let newLinks = [
        {
            href: '/ai/insights/incident',
            icon: ['fal', 'exclamation-circle'],
            title: 'Incident',
        },
        {
            href: '/ai/insights/serviceuser/',
            icon: ['fal', 'user-circle'],
            title: 'Service User',
        },
        {
            href: '/ai/insights/service/',
            icon: ['fal', 'home'],
            title: 'Service',
        }
    ]    
    setLinks(newLinks)
    
  }, [])





//   window.location.pathname

  return (
    <Box background='white' direction='column' gap='small' margin={{ bottom: 'medium' }} round='small' flex='grow'>
        <Box direction='row-responsive' justify='start' pad={{ horizontal: 'medium', vertical: 'small' }}>
        <Box alignSelf='center' direction='row-responsive' gap='xsmall'>
            {links.map((link, index) => (
                <ActionButton secondary={link.href === window.location.pathname} primary={link.href !== window.location.pathname} label={<Text size='medium'><FontAwesome icon={link.icon} /> {link.title}</Text>} margin={{ horizontal: 'xsmall' }} pad={{ horizontal: 'xsmall' }} onClick={() => navigate(link.href)} target='_self' />)
            )}
        </Box>
        </Box>
    </Box>
  )
}


// menuSetup.push({
    //   linkHref: '/incident/drafts',
    //   icon: 'pencil',
    //   linkTitle: 'Incomplete Incidents',
    // });


export default AILinkBar



